import { environment } from "./environments/environment";
import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import * as Sentry from "@sentry/angular-ivy";

import { AppModule } from "./app/app.module";

const CHUNK_LOAD_RELOAD_KEY = "kells_chunk_reload_attempted";

function isChunkLoadFailure(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }

  return (
    error.name === "ChunkLoadError" ||
    /loading chunk \d+ failed/i.test(error.message)
  );
}

function setupChunkLoadRecovery(): void {
  window.addEventListener("unhandledrejection", (event: PromiseRejectionEvent) => {
    if (!isChunkLoadFailure(event.reason)) {
      return;
    }

    const alreadyReloaded =
      sessionStorage.getItem(CHUNK_LOAD_RELOAD_KEY) === "true";
    if (alreadyReloaded) {
      return;
    }

    sessionStorage.setItem(CHUNK_LOAD_RELOAD_KEY, "true");
    window.location.reload();
  });
}

if (environment.production) {
  enableProdMode();
  Sentry.init({
    dsn:
      "https://906461f353008b6669cac606c2683cc6@o951759.ingest.us.sentry.io/4507190288252928",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

setupChunkLoadRecovery();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => sessionStorage.removeItem(CHUNK_LOAD_RELOAD_KEY))
  .catch((err) => console.error(err));
